import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2, Lock, UserPlus } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useSeo } from "@/lib/seo";

export default function Login() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  useSeo("Espace professionnel — Mon Projet Protégé");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      if (mode === "login") await login(form.email.trim(), form.password);
      else await register(form.email.trim(), form.password, form.name.trim());
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Une erreur est survenue.");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-4 py-16 sm:py-24">
      <div className="rounded-3xl bg-white border border-[#012141]/10 shadow-xl p-8">
        <span className="grid place-items-center w-14 h-14 rounded-2xl bg-[#012141] text-[#C89A3E] mx-auto"><ShieldCheck size={26} /></span>
        <h1 className="mt-5 text-2xl font-bold text-[#012141] font-heading text-center">{mode === "login" ? "Espace professionnel" : "Créer un compte conseiller"}</h1>
        <p className="mt-1 text-sm text-slate-500 text-center">{mode === "login" ? "Connexion réservée aux conseillers." : "Votre espace, vos prospects, votre boîte à outils."}</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          {mode === "register" && (
            <div><Label>Nom</Label><Input data-testid="register-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-xl mt-1.5" /></div>
          )}
          <div><Label>Courriel</Label><Input data-testid="login-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-xl mt-1.5" autoComplete="username" /></div>
          <div><Label>Mot de passe</Label><Input data-testid="login-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="rounded-xl mt-1.5" autoComplete={mode === "login" ? "current-password" : "new-password"} /></div>
          {error && <p data-testid="login-error" className="text-sm text-red-600">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-[#012141] text-white font-semibold hover:bg-[#00172E] disabled:opacity-60 transition-all">
            {loading ? <Loader2 className="animate-spin" size={18} /> : (mode === "login" ? <Lock size={16} /> : <UserPlus size={16} />)} {mode === "login" ? "Se connecter" : "Créer mon compte"}
          </button>
        </form>
        <button data-testid="toggle-auth-mode" onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }} className="mt-4 w-full text-sm text-[#012141] font-semibold hover:underline">
          {mode === "login" ? "Pas encore de compte ? Créer un compte conseiller" : "J'ai déjà un compte — me connecter"}
        </button>
      </div>
    </div>
  );
}
